// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__fprtC","row":"styles_row__2kHr1"};